import { createTRPCReact, inferReactQueryProcedureOptions } from "@trpc/react-query";
import { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import type { MainRouter } from "~/.server";

export const trpc = createTRPCReact<MainRouter>();

export type ReactQueryOptions = inferReactQueryProcedureOptions<MainRouter>;
export type RouterInputs = inferRouterInputs<MainRouter>;
export type RouterOutputs = inferRouterOutputs<MainRouter>;
